// import axios from 'axios'
import { post, put, get, remove } from '@/api/api'

export const actions = {
  fetchTarifs ({ commit}) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/tarif`).then(({ data }) => {
      commit("addTarifs", data);
    });
  },
  async fetchTarifPage({commit}, params = {}) {
    const { page = 0, size = 10, sort = '', libelle = '', montant = '', salle = '', after = '', before = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort, 
      ...(libelle && { libelle }),
      ...(montant && { montant }),
      ...(salle && { salle }),
      ...(after && { after }),
      ...(before && { before }),
    }).toString();

    let { data } = await get(`/canal/tarif/page?${queryParams}`);
    commit("addTarifsPage", data)
    return data;
  },
  createTarif ({ commit }, tarif) {
    return post('/canal/tarif', tarif)
      .then(({ data }) => {
        commit('addTarif', data)
      })
  },
  updateTarif ({ commit }, tarif) {
    return put(`/canal/tarif/${tarif.id}`, tarif)
      .then(({ data }) => {
        commit('replaceTarif', data)
      })
  },
  createOrUpdateTarif ({ dispatch }, tarif) {
    if (tarif.id !== undefined) {
      return dispatch('updateTarif', tarif)
    } else {
      return dispatch('createTarif', tarif)
    }
  },
  selectTarif ({ commit }, tarif) {
    commit('setTarif', tarif)
  },
  deleteTarif ({ commit}, tarif) {
    return remove(`/canal/tarif/${tarif.id}`)
      .then(({ data }) => {})
  },
}
